<div class="ep-overlay" [class.open]="open" (click)="close()">
	<div class="ep-panel" *ngIf="open" (click)="$event.stopPropagation()">

		<header class="ep-header">
			<h2>Edit Profile</h2>
			<button type="button" class="ep-close" (click)="close()" aria-label="Close"><i class="wq wq-close"></i></button>
		</header>

		<form class="ep-body" (ngSubmit)="submit()">
			<div class="ep-avatar portal-avatar">{{ avatarInitials }}</div>

			<div class="ep-row">
				<div class="form-group">
					<label for="ep-first">First name</label>
					<input id="ep-first" class="form-control" type="text" name="firstName" placeholder="First name"
						[(ngModel)]="firstName" autocomplete="given-name" />
				</div>
				<div class="form-group">
					<label for="ep-last">Last Name</label>
					<input id="ep-last" class="form-control" type="text" name="lastName" placeholder="Last name"
						[(ngModel)]="lastName" autocomplete="family-name" />
				</div>
			</div>

			<div class="form-group">
				<label for="ep-phone">Contact number</label>
				<div class="ep-phone-row">
					<select class="form-control ep-dial" name="dialCode" [(ngModel)]="dialCode">
						<option *ngFor="let d of dialCodes" [value]="d.code">{{ d.label }}</option>
					</select>
					<input id="ep-phone" class="form-control" type="tel" name="phone" placeholder="Phone number"
						[(ngModel)]="phone" autocomplete="tel-national" />
				</div>
			</div>

			<div class="form-group">
				<label for="ep-email">Email</label>
				<input id="ep-email" class="form-control" type="email" name="email" placeholder="name@example.com"
					[(ngModel)]="email" autocomplete="email" />
			</div>

			<hr class="ep-divider" />

			<h3 class="ep-section-title">Change Password</h3>

			<div class="form-group">
				<label for="ep-current">Current password</label>
				<div class="ep-pw">
					<input id="ep-current" class="form-control" [type]="show.current ? 'text' : 'password'" name="currentPassword"
						[(ngModel)]="currentPassword" autocomplete="current-password" />
					<button type="button" class="ep-eye" (click)="show.current = !show.current" [attr.aria-label]="show.current ? 'Hide password' : 'Show password'">
						<svg *ngIf="!show.current" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>
						<svg *ngIf="show.current" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
					</button>
				</div>
			</div>

			<div class="form-group">
				<label for="ep-new">New password</label>
				<div class="ep-pw">
					<input id="ep-new" class="form-control" [type]="show.new ? 'text' : 'password'" name="newPassword"
						[(ngModel)]="newPassword" autocomplete="new-password" />
					<button type="button" class="ep-eye" (click)="show.new = !show.new" [attr.aria-label]="show.new ? 'Hide password' : 'Show password'">
						<svg *ngIf="!show.new" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>
						<svg *ngIf="show.new" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
					</button>
				</div>
			</div>

			<div class="form-group">
				<label for="ep-conf">Confirm new password</label>
				<div class="ep-pw">
					<input id="ep-conf" class="form-control" [type]="show.conf ? 'text' : 'password'" name="passwordConf"
						[(ngModel)]="passwordConf" autocomplete="new-password" />
					<button type="button" class="ep-eye" (click)="show.conf = !show.conf" [attr.aria-label]="show.conf ? 'Hide password' : 'Show password'">
						<svg *ngIf="!show.conf" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>
						<svg *ngIf="show.conf" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
					</button>
				</div>
			</div>

			<div class="portal-error" *ngIf="error">{{ error }}</div>
		</form>

		<footer class="ep-footer">
			<button type="button" class="btn btn-outline-secondary w-100" (click)="close()" [disabled]="saving">Cancel</button>
			<button type="button" class="btn btn-primary w-100" (click)="submit()" [disabled]="saving">{{ saving ? 'Saving…' : 'Update' }}</button>
		</footer>
	</div>
</div>
